import React, { useState, useEffect } from "react";
import Banner from "./Banner/Banner";
import Leaderboard from "./Leaderboard/Leaderboard";
import AuctionNFTs from "./AuctionNfts/AuctionNFTs";
import Benefits from "./Benefits/Benefits";
import Checkout from "./Checkout/Checkout";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import { common, privateNav, publicNav } from "../../utils/navItems";
import Faq from "../../GlobalComponents/Faq/Faq";
import Footer from "../../GlobalComponents/Footer/Footer";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";
import Web3 from "web3";
import abi from "../../constants/abi";
import contracts from "../../constants/contracts";
import { useBalance,useWalletClient, useAccount } from "wagmi";
import multicall from "utils/multicall";
import { bid } from './interface';
import getNodeUrl from "../../utils/getRpcUrl";
import { useConnectModal, useAccountModal, useChainModal } from "@rainbow-me/rainbowkit";

var rpc = getNodeUrl();
//var web3 = new Web3(new Web3.providers.HttpProvider(rpc));

/*
var myrpc = window && window.ethereum ? window.ethereum : rpc;
console.log(window.ethereum)
var   web3 = new Web3(new Web3.providers.HttpProvider(rpc));
if (window.ethereum) {
  web3 = new Web3(window.ethereum);
  try {
    await window.ethereum.request({ method: "eth_requestAccounts" });
  } catch (e) {
    console.error("User denied account access");
  }
}
*/
//const web3 = new Web3(new Web3.providers.HttpProvider(myrpc));
//const provider = new ethers.providers.Web3Provider(window.ethereum);
//const contract = new web3.eth.Contract(abi.AUCTION, contracts.AUCTION);


const NftAuction = () => {
  var { account } = useAccount();
  const { data: signer } = useWalletClient();
  const [bidAmount, setbidAmount] = useState(0);
  const [Bid, setBid] = useState(0);
  const [mybid, setmybid] = useState(0);
  const [dataToLeaderBoard, setdataToLeaderBoard] = useState([]);
  const [dataToBanner, setdataToBanner] = useState([]);
  const [refreshit, setrefreshit] = useState(false);
  const { openConnectModal } = useConnectModal();
  const [address, setAddress] = useState("");

  //multicall
  useEffect(() => {
    try{

   if (!account) account='0x0000000000000000000000000000000000000000'

    async function main() {
      var callsALL = [
        {
          account: contracts.AUCTION,
          params: [],
          name: "getLength",
        },
        {
          account: contracts.AUCTION,
          params: [],
          name: "getBids",
        },
        {
          account: contracts.AUCTION,
          params: [],
          name: "getLengthofUniqueBids",
        },
        {
          account: contracts.AUCTION,
          params: [account],
          name: "userInfo",
        },
        {
          account: contracts.AUCTION,
          params: [],
          name: "minBid",
        },
        {
          account: contracts.AUCTION,
          params: [],
          name: "maxBid",
        },
        {
          account: contracts.AUCTION,
          params: [1],
          name: "getSortedBiddersforBracket",
        },
        {
          account: contracts.AUCTION,
          params: ['0xFE70d8c03D233cFcfcd2E9eAc4181aD590C44B67'],
          name: "findRankOfAddress",
        },
      ];
      let topBiddersLength;
      let getBids;
      let totalBidsis;
      let mybidIs;
      let minBidis;
      let maxBidis;
      let getTopBiddersis;
      let getTopBidderBidssis;
      let myRankis;
    //  let totalBidsis;

      [topBiddersLength,
        getBids,
        totalBidsis,
        mybidIs,
        minBidis,
        maxBidis,
        getTopBiddersis,
        myRankis,
      //  totalBidsis
      ] = await multicall(abi.AUCTION, callsALL);

      var callsALL2 = [
        {
          account: contracts.AUCTION,
          params: getTopBiddersis,
          name: "getBalances",
        },
      ];
      [getTopBidderBidssis] = await multicall(abi.AUCTION, callsALL2);
  console.log(getTopBiddersis,getTopBidderBidssis[0])
      // Pairing accountes with amounts
var pairedArray = getTopBiddersis[0].map((account, i) => {
  var amount = getTopBidderBidssis[0][i]._hex;  // Accessing the _hex property from the BigNumber object
  return { account, amount };
});

//console.log(pairedArray);

      setdataToLeaderBoard([
        topBiddersLength,
        totalBidsis,
        pairedArray,
   
      ]);
      setdataToBanner([minBidis, maxBidis,myRankis]);
      setmybid(Number(mybidIs.balances) / 10 ** 18);
    }
    main();
  }catch(e){
    console.log(e)
  }
  }, [account, refreshit]);



  const handleChildClick = async (value) => {
    try {
      await bid(value, openConnectModal);
      //await bid(value)
      setrefreshit(!refreshit);

    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <NavLayout
        navItems={publicNav}
        bold={true}
        setAddress={setAddress}
        buttons={
          <div className="button-container">
            <button className=" w-[120px] h-10 border font-normal text-res-xs leading-[19px] border-solid border-main-green">
              <span>R34P</span>
              <span className="font-black"> $36.65</span>
            </button>
            <ConnectButton></ConnectButton>
          </div>
        }
      ></NavLayout>
      <Banner
        mybid={mybid}
        Bid={Bid}
        dataToBanner={dataToBanner}
        time={2591980}
        handleChildClick={handleChildClick}
      ></Banner>
      <Leaderboard dataToLeaderBoard={dataToLeaderBoard} />
      <AuctionNFTs />
      <Benefits />
      <div className="mt-[102px] mb-[100px]">
        <Faq />
      </div>
      <div className="mt-10">
        <Footer />
      </div>
    </>
  );
};

export default NftAuction;
